<template>
	<VInputMask
		ref="company-inn-input"
		:value="company.additionalAttributes.inn.value"
		:label="company.additionalAttributes.inn.name"
		@input="value => company.additionalAttributes.inn.value = value"
		layout="vertical"
		:precision="0"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="### ### ###"
		:validate-method="UzUtils.validateINN"
		:disabled="readOnly"
	/>

	<VSwitch
		v-model="company.isVatPayer"
		layout="vertical"
		theme="slider"
		label="Плательщик НДС"
		checked-label="Да"
		unchecked-label="Нет"
		:disabled="readOnly"
	/>

	<VSelectV2
		v-model="company.vatRate"
		label="Ставка НДС"
		layout="vertical"
		hide-clear-btn
		:data="vatRateLoader"
		:disabled="readOnly || company.isVatPayer === false || company.availableVatRates.length <= 1"
	/>
</template>

<script>

import UzUtils from '@/core/utils/regional/UzUtils'
import Company from "@/domains/Companies/Company.js";
import VatRate from '@/core/types/VatRate';

export default {
	name:   'UZAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		/**
		 * Ставки НДС. Перезагружаются при смене признака плательщика;
		 * единственная ставка подставляется сама. Неплательщику — нулевая ставка.
		 */
		const vatRateLoader = this.$core.loader.select(({ isVatPayer }) => {
			if (isVatPayer === false) {
				return [VatRate.zero()];
			}
			else {
				return this.company.availableVatRates;
			}
		})
			.dependsOn({
				isVatPayer: () => this.company.isVatPayer,
			})
			.preloadOnMount();

		return {
			UzUtils,
			vatRateLoader,
		}
	},
};
</script>